export default "__VITE_PUBLIC_ASSET__f00cff02__"